import { Theme, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Webviewer } from "@thingsw/pitta-modules";
import React from "react";

import SimpleBarReact from "simplebar-react";
import "simplebar/src/simplebar.css";

interface ScrollBarProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const ScrollBar = React.forwardRef<any, any>(
  ({ children, style }: ScrollBarProps, ref) => {
    const theme = useTheme() as Theme;
    const mobile = useMediaQuery(theme.breakpoints.down(Webviewer.mobile));

    return mobile ? (
      <>{children}</>
    ) : (
      <SimpleBarReact style={{ height: "100%", overflowX: "hidden", ...style }}>
        <div ref={ref}>{children}</div>
      </SimpleBarReact>
    );
  }
);
